import type { ConstructorArgs } from "@webiny/db";
import { Db } from "@webiny/db";
import { createRegisterExtensionPlugin } from "@webiny/handler";
import type { DbContext } from "./types.js";

export default <T = unknown>(args: ConstructorArgs<T>) => {
    const plugin = createRegisterExtensionPlugin<DbContext>(async context => {
        if (context.db) {
            return;
        }
        context.db = new Db<T>(args);
    });
    plugin.name = "handler-db/extension/db";
    return [plugin];
};
